import React from 'react';
import styled from 'styled-components';
import mediaQ from './responsive';

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
`;

export const Container = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    ${mediaQ.tablet`
        max-width: 960px;
    `}
    ${mediaQ.phone`
        max-width: 420px;
    `}
`;

export const LabelCol = styled.div`
    -ms-flex: 0 0 40%;
    flex: 0 0 40%;
    min-width: 40%;
    ${mediaQ.tablet`
        width: 100%;    
        max-width: 100%;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
    `}
`;

export const ContentCol = styled.div`
    -ms-flex: 0 0 60%;
    flex: 0 0 60%;
    max-width: 60%;
    ${mediaQ.tablet`
        width: 100%;    
        max-width: 100%;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
    `}
`;
